import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AdminJobReview from "@/components/AdminJobReview";

export default function AdminJobQueue() {
  const [draft, setDraft] = useState({ q: "", country: "" });
  const [filters, setFilters] = useState({ q: "", country: "" });
  const [page, setPage] = useState(1);
  const [revision, setRevision] = useState(0);
  const [result, setResult] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [approvalMessage, setApprovalMessage] = useState("");
  useEffect(() => {
    let active = true;
    setLoading(true); setError("");
    api.get("/admin/jobs/review-queue", { params: { ...filters, page } })
      .then(({ data }) => {
        if (!active) return;
        if (!data.items.length && page > 1 && data.total <= (page - 1) * 25) {
          setPage(Math.max(1, Math.ceil(data.total / 25))); return;
        }
        setResult(data);
      }).catch(() => { if (active) setError("Unable to load vacancies. Try again."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [filters, page, revision]);
  const pages = Math.max(1, Math.ceil(result.total / 25));
  return <section className="mt-8 card p-6" data-testid="admin-approvals">
    <h2 className="text-lg font-semibold">Vacancies awaiting approval</h2>
    {approvalMessage && <p role="status" className="mt-3 text-sm text-slate-700">{approvalMessage}</p>}
    <form className="mt-4 flex flex-wrap gap-2" onSubmit={(e) => { e.preventDefault(); setPage(1); setFilters({ ...draft }); }}>
      <input className="field" aria-label="Search vacancies" placeholder="Job title, company or source" maxLength={200} value={draft.q} onChange={(e) => setDraft({ ...draft, q: e.target.value })} />
      <input className="field" aria-label="Filter by country" placeholder="Country, e.g. United Kingdom" maxLength={80} value={draft.country} onChange={(e) => setDraft({ ...draft, country: e.target.value })} />
      <button className="btn btn-primary" type="submit">Search</button>
      <button className="btn btn-ghost" type="button" onClick={() => { setDraft({ q: "", country: "" }); setFilters({ q: "", country: "" }); setPage(1); }}>Clear filters</button>
    </form>
    {error && <p role="alert" className="mt-3 text-red-700">{error}<button className="btn btn-ghost ml-2" onClick={() => setRevision((n) => n + 1)}>Retry</button></p>}
    {loading ? <p className="mt-4" role="status">Loading vacancies…</p> : !error && <>
      <p className="mt-4 text-sm text-slate-600">{result.total} matching vacancies · Page {page} of {pages}</p>
      <ul className="mt-3 space-y-2 text-sm">{result.items.map((job) => <AdminJobReview key={job.id} job={job} onApproved={(message) => { setApprovalMessage(message || "Vacancy changes saved."); setRevision((n) => n + 1); }} />)}</ul>
      {!result.items.length && <p className="mt-4 text-slate-500">No vacancies match these filters.</p>}
      <div className="mt-4 flex gap-2"><button className="btn btn-ghost" disabled={page <= 1} onClick={() => setPage(page - 1)}>Previous</button><button className="btn btn-ghost" disabled={page >= pages} onClick={() => setPage(page + 1)}>Next</button></div>
    </>}
  </section>;
}
